import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private auth = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const redirectUrl = state.url;

    // If we have a valid (non-expired) access token and user info, allow navigation immediately.
    if (this.auth.isAuthenticated() && !!this.auth.getUserInfo()) {
      return true;
    }

    const refreshToken = this.auth.getRefreshToken();
    if (!refreshToken) {
      this.auth.localLogout(redirectUrl);
      return this.router.createUrlTree(['/auth/login'], { queryParams: { redirectUrl } });
    }

    // We have a refresh token, so attempt refresh *before* allowing entry to /app.
    return this.auth.refreshToken().pipe(
      map(() => true),
      catchError(() => {
        this.auth.localLogout(redirectUrl);
        return of(this.router.createUrlTree(['/auth/login'], { queryParams: { redirectUrl } }));
      })
    );
  }
}
